import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { FsSidenavModule, MENU_DATA, SidenavMenuRef } from '@firestitch/sidenav';

import { AccountData } from '@common/data';


@Component({
    templateUrl: './parent-menu.component.html',
    styleUrls: ['./parent-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FsSidenavModule],
})
export class ParentMenuComponent {
  data = inject(MENU_DATA);
  dialog = inject(MatDialog);
  router = inject(Router);
  accountData = inject(AccountData);
  menuRef = inject<SidenavMenuRef<ParentMenuComponent>>(SidenavMenuRef);


  public close(): void {
    this.menuRef.close();
  }

  public switchOrganization(): void {
    this.accountData.experienceSwitch('organization')
      .subscribe(() => {
        this.close();
        this.router.navigateByUrl('/');
      });
  }

}
